import { Location, useLocation } from "react-router-dom";

import Button from "components/Button";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageTracking } from "hooks/usePageTracking";

interface State {
  state: {
    redirect: Location;
  };
}

export const BrowserNotSupported = () => {
  const { state } = useLocation() as unknown as State;
  const { t } = useClientTranslation();

  // Sometimes state is null
  const URL = state?.redirect;

  usePageTracking({ name: "Error - view", properties: { type: "Browser not supported" } });

  return (
    <PageLayout
      title={t("error.wrong_browser.header")}
      bottomButtons={
        URL ? (
          <Button
            href={`intent://${URL}#Intent;scheme=https;package=com.android.chrome;end`}
            rel="noopener noreferrer"
            component="a"
          >
            {t("error.wrong_browser.open_chrome")}
          </Button>
        ) : null
      }
    >
      <Text sizeVariant="md" mt={24} mx={24}>
        {t("error.wrong_browser.instruction")}
      </Text>
    </PageLayout>
  );
};
